import { type CampaignCreationSharedJobInformationFormData } from 'modules/campaign-creation-shared/forms';
import { SharedSourcingStoreApi } from 'modules/sourcing-shared/types';
import { scrollToTop } from 'common/utils';

type HandleSourcingSharedJobInformationNextControllerProps = {
  jobInformationFormData: CampaignCreationSharedJobInformationFormData;
  set: SharedSourcingStoreApi['setState'];
};

export const handleSourcingSharedJobInformationNextController = ({
  jobInformationFormData,
  set
}: HandleSourcingSharedJobInformationNextControllerProps) => {
  scrollToTop();
  set({
    step: 'SETUP_APPLICATION',
    jobInformationFormData
  });
};
